class User {
  static STATUS_GUEST = 'GUEST';
	static STATUS_PENDING = 'PENDING';
	static STATUS_ACTIVE = 'ACTIVE';
	static STATUS_DELETED = 'DELETED';
}

export default User;
